import { ThemeIcon } from '@mantine/core';
import { IconArrowDownRight, IconArrowUpRight } from '@tabler/icons-react';
import dayjs from 'dayjs';

import styles from './LinkedExpenseItem.module.scss';
import { Props } from './LinkedExpenseItem.types';

const LinkedExpenseItem = ({ item, onClick }: Props) => {
  const amount = item.metadata?.amount as number | undefined;
  const isIncome = item.metadata?.isIncome as boolean | undefined;
  const paidAt = item.metadata?.paidAt as string | undefined;

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon size={36} radius="md" variant="light" color={isIncome ? 'teal' : 'orange'}>
        {isIncome ? <IconArrowUpRight size={18} /> : <IconArrowDownRight size={18} />}
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {paidAt && <span className={styles.subtitle}>{dayjs(paidAt).format('DD/MM/YYYY')}</span>}
      </div>
      {amount != null && (
        <span className={`${styles.amount} ${isIncome ? styles.income : styles.expense}`}>
          {isIncome ? '+' : '-'}
          {Math.abs(amount).toLocaleString('fr-FR')} €
        </span>
      )}
    </div>
  );
};

export default LinkedExpenseItem;
